import React from 'react';
import { debounce } from 'helpers/debounce';

/* What is this trying to solve?
 * On mobile devices the vh unit is based on the viewport rather than the visible area hence causing an inconsistent/undesirable experience for the user.
 *
 * How does this component solve that issue?
 * This component sets a css variable called --vh with the correct vh unit that can be used in css
 * For a detailed explanation on this issue please read:
 * https://nicolas-hoizey.com/2015/02/viewport-height-is-taller-than-the-visible-part-of-the-document-in-some-mobile-browsers.html
 * For a more detailed explanation on this solution please read:
 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */

export function FullHeight(WrappedComponent) {
  return class extends React.Component {
    componentDidMount() {
      if (__CLIENT__) {
        this.setViewHeight();
        window.addEventListener('resize', debounce(this.setViewHeight));
      }
    }

    componentWillUnmount() {
      if (__CLIENT__) {
        window.removeEventListener('resize', debounce(this.setViewHeight));
      }
    }

    setViewHeight() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      const vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
